import React from 'react';
import styled from 'styled-components';
import { CreateFormTheme } from '../../../utils/themes';
import DuplicateIcon from '../../../assets/icons/DuplicateIcon';
import DeleteIcon from '../../../assets/icons/DeleteIcon';
import { useTheme } from '../../../middleware/ThemeContext';


export const ActionsWrapper = styled.div`
  position: absolute;
  top: -50px;
  right: -14px;
  display: flex;
  gap: 0;
  width: fit-content;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;


  overflow: hidden;
  z-index: 100;
`;

export const IconsSection = styled.div`
  background: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 0;
  padding: 8px 6px;
  // border-radius: 4px 0 0 4px;
`;

export const IconActionButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: white;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
`;

export const EditSection = styled.button`
  background: #FF6D41;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  color: white;
  font-size: 13px;
  font-weight: 600;
  // border-radius: 0 4px 4px 0;
  transition: all 0.2s ease;
  
  &:hover {
    background: #FF6D41;
    opacity: 0.9;
    }
  
  &:active {
    transform: scale(0.98);
  }
`;

// Export for backward compatibility
export const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({theme}) => theme?.CorporateTheme?.colors?.textSecondary};
  &:hover {
    color: ${({theme}) => theme?.CorporateTheme?.colors?.textPrimary};
  }
`;

const FieldActions: React.FC<{
  onEdit: () => void;
  onCopy: () => void;
  onDelete: () => void;
  fieldName?: string;
}> = ({ onEdit, onCopy, onDelete, fieldName }) => {
  const { theme } = useTheme();
  return (
    <ActionsWrapper theme={theme}>
      <IconsSection className='mb-3'>
        <IconActionButton
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete();
          }}
          title="Delete"
        >
          <DeleteIcon size={16} color="white" />
        </IconActionButton>
        <IconActionButton
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCopy();
          }}
          title="Duplicate"
        >
          <DuplicateIcon size={16} color="white" />
        </IconActionButton>
      </IconsSection>
      <EditSection
        className='mb-3'
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onEdit();
        }}
        title="Edit"
        theme={theme}
      >
        Edit {fieldName}
      </EditSection>
    </ActionsWrapper>
  );
};

export default FieldActions;
